export default "__VITE_ASSET__bf2fe763__"